import { ArrowRightOutline24Icon } from "@vygruppen/spor-icon-react";
import TransferWithSearch from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferWithSearch";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { DropsButton } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";

type Props = {
  requestId: string;
};

const ShowTransferWithSearch: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <DropsButton
      variant="tertiary"
      size="sm"
      leftIcon={<ArrowRightOutline24Icon />}
      onClick={onClick}
    >
      {t("Sett videre")}
    </DropsButton>
  );
};

const CallTransfer = (props: Props) => {
  const [showTransfer, setShowTransfer] = useState(false);
  const { t } = useTranslation();

  const { requestId } = props;
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {!showTransfer ? (
        <ShowTransferWithSearch
          onClick={() => {
            setShowTransfer(true);
          }}
        />
      ) : (
        <>
          <Text>{t("Sett videre:")}</Text>
          <TransferWithSearch
            requestId={requestId}
            closeSearch={() => setShowTransfer(false)}
          />
        </>
      )}
    </div>
  );
};

export default CallTransfer;
